module.exports = __webpack_public_path__ + "img/followUpSettings.1290ccbe.svg";